import axios from "axios";

export default axios.create({
  baseURL: window._env_.REACT_APP_POS_ENGINE_ENDPOINT
});
